import { useEffect } from "react";
import { useAuth } from 'react-oidc-context';


export function UnloadAppProvider({ children }: { children: any }) {
  
  const auth = useAuth();
  
  useEffect(() => {

    const handleUnload = () => {
      if(auth.isAuthenticated)
      {
          auth.removeUser();
      }
    };

    window.addEventListener("unload", handleUnload);

    return () => {
      window.addEventListener("unload", handleUnload);
    };
  }, [auth, auth.isAuthenticated]);

  return children;
}